import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import{ LoopBackAuth,  validacionService, asignaturaAreaService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'modal-form-asignatura-area',
  templateUrl: './modal-form-asignatura-area.component.html',
  providers:[LoopBackAuth, asignaturaAreaService, validacionService, MessageService]
})
export class ModalFormAsignaturaAreaComponent implements OnInit {
  @Input() fromAsignaturaAreas : FormGroup
  spinner: boolean = true
  constructor(
    public activeModal: NgbActiveModal,
    private asignaturaAreaService:asignaturaAreaService,
    private fb: FormBuilder,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
  }

  validarForm(): boolean{
    let valFrom = true
    Object.keys(this.fromAsignaturaAreas.controls).forEach(field =>{
      const control = this.fromAsignaturaAreas.get(field);

      if(!control.valid && (control.value == null || control.value == "")){
        valFrom = false
        control.markAsTouched({ onlySelf: true })
      }
    })
    return valFrom
  }
  
  onSave(){
    if(this.validarForm()){
      this.spinner = false
      console.log("datos save -->",this.fromAsignaturaAreas.getRawValue() )
      this.asignaturaAreaService.create(this.fromAsignaturaAreas.getRawValue()).subscribe(
        item =>{
          if(item != null){
            this.toastr.success('Se actualizo el área','Éxito');
            this.activeModal.close(item)
          }else{
            this.toastr.warning('El Área ya existe','Alerta');
          }
          this.spinner = true
        }
      )
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-form-asignatura-area/modal-form-asignatura-area.component.ts